import { createContext, useContext } from "react";

const DashboardSideBarContext = createContext();
const DashboardSideBarProvider = DashboardSideBarContext.Provider;
const useDashboardSideBarContext = () => useContext(DashboardSideBarContext);

export { DashboardSideBarContext, DashboardSideBarProvider, useDashboardSideBarContext };
